import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as accountCampaignPricingEmailActions from "../actions/account_campaign_pricing_email_actions";
import * as accountCampaignPricingEmailTypes from "../types/account_campaign_pricing_email_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";
import { endpoints } from "../endpoints";

function* getPricingOfAccountEmailCampaign(action) {
  try {
    const res = yield call(api.get, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_EMAIL}/${action.payload.id}`);
    if (res.status === 200) {
      yield put(accountCampaignPricingEmailActions.getPricingOfAccountEmailCampaignSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingEmailActions.getPricingOfAccountEmailCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingEmailActions.getPricingOfAccountEmailCampaignError(e));
  }
}

function* editPricingOfAccountEmailCampaign(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_EMAIL}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(accountCampaignPricingEmailActions.editPricingOfAccountEmailCampaignSuccess(res.data));
      yield put(accountCampaignPricingEmailActions.getPricingOfAccountEmailCampaignRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingEmailActions.editPricingOfAccountEmailCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingEmailActions.editPricingOfAccountEmailCampaignError(e));
  }
}

export default function* accountCampaignPricingEmailSaga() {
  yield takeLatest(accountCampaignPricingEmailTypes.getPricingOfAccountEmailCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_REQUEST, getPricingOfAccountEmailCampaign);
  yield takeLatest(accountCampaignPricingEmailTypes.editPricingOfAccountEmailCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_REQUEST, editPricingOfAccountEmailCampaign);
}
